/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $ = jQuery;
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});



    $(function () {
      $(document).scroll(function () {
        var $nav = $(".ie-nav");
        $nav.toggleClass('navAction', $(this).scrollTop() > $nav.height());
      });
    });

    $('.hamburger-toggle').click(function(){
      $('.mobile-menu-drop').slideToggle(400);
      // $(this).siblings('.mobile-menu-drop').toggleClass('show-mobile-nav');
      $(this).children('.hamburgerMenu').toggleClass('menuIsOpened');
    });
  
    $(function(){
      var current = window.location.pathname;
      if(window.location.pathname != '/') {
        $('.navItem a').each(function(){
          var $this = $(this);
          // if the current path is like this link, make it active
          if($this.attr('href').indexOf(current) !== -1){
              $this.addClass('active');
          }
      })
      }
  })

  $('.commercial-container').click(function(e) {
    e.preventDefault();
    // $('.commercial-grid').toggleClass('hidden');
    $('.residential-container').removeClass('btn-primary');
    $('.residential-container').addClass('btn-secondary');
    $('.commercial-container').removeClass('btn-secondary');
    $('.commercial-container').addClass('btn-primary');
    $('.commercial-grid').slideToggle(500)
    $('.residential-grid').addClass('hidden');
    $('.residential-grid').slideUp(500);
  })
  $('.residential-container').click(function(e) {
    e.preventDefault();
    // $('.residential-grid').toggleClass('hidden')
    $('.commercial-container').removeClass('btn-primary');
    $('.commercial-container').addClass('btn-secondary');
    $('.residential-container').removeClass('btn-secondary');
    $('.residential-container').addClass('btn-primary');
    $('.residential-grid').slideToggle(500);
    $('.commercial-grid').addClass('hidden');
    $('.commercial-grid').slideUp(500)
  });


  $(function () {
    $(".dropdown-nav-menu-container-mobile").click(function () {
        $(this).find(".dropdown-menu-mobile").slideToggle('slow');
    });
  });
  
//accordian

$('.slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  // dots: true
});

$('.hero-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 5000,
});

$('a[data-slide]').click(function(e) {
  e.preventDefault();
  var slideno = $(this).data('slide');
  $('.slider').slick('slickGoTo', slideno - 1);
  $('a[data-slide]').removeClass('active');
  this.classList.add('active');
});
    $.fn.ashCordian = function() {
  
      var container = $(this);
    
      container.find('.panelTitle').click(function() {
        if($(this).siblings('.panelContent').css('display') == 'block'){
           container.find('.panelContent').slideUp(400);
           container.find('.fa-plus-circle').removeClass('rotateIcon')
           
        } else {
          container.find('.panelContent').slideUp(400);
          container.find('.fa-plus-circle').removeClass('rotateIcon')
           $(this).siblings('.panelContent').slideDown(400);
           $(this).children('.fa-plus-circle').addClass('rotateIcon');
        }
      });
    };
    
    
    $('.servicesAccordian').ashCordian();
    
}); 

